import React, { useState, useEffect } from 'react';
import { Drawer } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import TextInput from '../../forms/TextInput';
import TextArea from '../../forms/TextAreaField';
import {
  DrawerContainer,
  DrawerHeader,
  DrawerHeaderLeft,
  DrawerHeaderTitle,
  DrawerHeaderCloseButton,
  DrawerHeaderSaveButton,
  DrawerContent,
  DrawerTitle,
  FormField,
  FormLabel,
  FormLabelIcon,
  FormInputWrapper,
  FormInputDescriptionOptional,
} from './EditCampaignDetailsDrawer.styled';
import { CampaignNameIcon, CampaignDescriptionIcon } from '../../SVGs/Icons';

const EditCampaignDetailsDrawer = ({
  open,
  onClose,
  campaignName,
  description,
  onSave,
}) => {
  const [name, setName] = useState(campaignName || '');
  const [desc, setDesc] = useState(description || '');

  // Sync state when props change (when drawer opens)
  useEffect(() => {
    if (open) {
      setName(campaignName || '');
      setDesc(description || '');
    }
  }, [open, campaignName, description]);

  const handleClose = () => {
    // Save changes when closing
    if (onSave) {
      onSave({ name, description: desc });
    }
    onClose();
  };

  return (
    <Drawer anchor="right" open={open} onClose={handleClose}>
      <DrawerContainer>
        <DrawerHeader>
          <DrawerHeaderLeft>
            <DrawerHeaderCloseButton onClick={handleClose}>
              <CloseIcon />
            </DrawerHeaderCloseButton>
            <DrawerHeaderTitle>Campaign Details</DrawerHeaderTitle>
          </DrawerHeaderLeft>
          <DrawerHeaderSaveButton onClick={handleClose}>
            Save
          </DrawerHeaderSaveButton>
        </DrawerHeader>
        <DrawerContent>
          <DrawerTitle>Edit Campaign Details</DrawerTitle>

          <FormField>
            <FormLabel>
              <FormLabelIcon>
                <CampaignNameIcon />
              </FormLabelIcon>
              Campaign name
            </FormLabel>
            <FormInputWrapper>
              <TextInput
                fullWidth
                placeholder="Campaign Name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </FormInputWrapper>
          </FormField>

          <FormField>
            <FormLabel>
              <FormLabelIcon>
                <CampaignDescriptionIcon />
              </FormLabelIcon>
              Description{' '}
              <FormInputDescriptionOptional>
                (optional)
              </FormInputDescriptionOptional>
            </FormLabel>
            <FormInputWrapper>
              <TextArea
                fullWidth
                placeholder="Campaign Description"
                value={desc}
                onChange={e => setDesc(e.target.value)}
              />
            </FormInputWrapper>
          </FormField>
        </DrawerContent>
      </DrawerContainer>
    </Drawer>
  );
};

export default EditCampaignDetailsDrawer;
